import appDownloadIcon from './header-appdownload-icon.svg';
import customerIcon from './header-customer-icon.svg';
import customerServiceIcon from './icon-customer.svg';

/** Reference CDN assets stored locally. customerService is MCW icon-customer.svg. */
export const HEADER_ICON_SRC = {
  appDownload: appDownloadIcon,
  customer: customerIcon,
  customerService: customerServiceIcon,
};
